import PropTypes from 'prop-types';
import React from 'react';
import List from 'yoda-core-components/lib/components/List/List';
import config from 'yoda-core-components/lib/components/List/List/List.config';
import GiftWrapper from '../GiftWrapper/GiftWrapper';

function GiftWrapperList({ giftWrapsInfo, currency }) {
    const giftWrapRenderer = (giftWrap, index) => (
        <GiftWrapper giftWrap={giftWrap} index={index} currency={currency} />
    );

    return (
        <div>
            <List
                direction={config.direction.VERTICAL}
                spacing={config.spacing.NONE}
                itemSpacing={config.spacing.NONE}
                datasource={giftWrapsInfo}
                childRenderer={giftWrapRenderer}
            />
        </div>
    );
}

GiftWrapperList.defaultProps = {
    currency: 'USD',
};

GiftWrapperList.propTypes = {
    giftWrapsInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
    currency: PropTypes.string,
};

export default GiftWrapperList;
